module.exports = __webpack_public_path__ + "img/1321.582b06fb.gif";